import {
  PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_BEGIN,
  PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_DISMISS_ERROR,
  PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_FAILURE,
  PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_SUCCESS,
} from './constants';

import ApiUrls from '../../../../services/apiUrls';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function applyPromoCode(args = {}) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.post(ApiUrls.promoCode(), args.data);
      doRequest.then(
        res => {
          dispatch({
            type: PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_SUCCESS,
            data: res,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissApplyPromoCodeError() {
  return {
    type: PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        applyPromoCodePending: true,
        applyPromoCodeError: null,
      };

    case PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_SUCCESS:
      // The request is success
      return {
        ...state,
        applyPromoCodePending: false,
        applyPromoCodeError: null,
      };

    case PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_FAILURE:
      // The request is failed
      return {
        ...state,
        applyPromoCodePending: false,
        applyPromoCodeError: action.data.error,
      };

    case PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        applyPromoCodeError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/redux/applyPromoCode.js